<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-layout>
        <v-flex xs11>
            <span>Прикрепления:</span>
            <v-card flat tranparent>
                <v-container grid-list-sm fluid>
                    <v-layout wrap>
                        <v-flex
                                v-for="attachment in attachments"
                                :key="attachment.id"
                                xs4
                                d-flex
                                child-flex
                                flat
                        >
                            <v-card flat tile class="d-flex">
                              <v-card flat v-if="attachment.type < 2">
                                <v-img

                                        :src="attachment.type === 0 ? attachment.link : '/static/video.jpg'"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                >
                                    <template v-slot:placeholder>
                                        <v-row
                                                fill-height
                                                align-center
                                                justify-center
                                                ma-0
                                        >
                                            <v-progress-circular
                                                indeterminate
                                                color="grey lighten-5"
                                            ></v-progress-circular>
                                        </v-row>
                                    </template>
                                </v-img>
                                <span class="font-weight-light">{{attachment.caption}}</span>
                              </v-card>
                                <v-card v-else flat>
                                    <v-card-text class="text-truncate pa-1" link :href="attachment.link">
                                        <p class="text-center mb-1">
                                        <a  :href="attachment.link.replace('&no_preview=1','')" target="_blank">
                                            <v-icon large>insert_drive_file</v-icon>
                                        </a>
                                        </p>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <span v-on="on">{{attachment.caption}}</span>
                                            </template>
                                            <span>{{attachment.caption}}</span>
                                        </v-tooltip>
                                    </v-card-text>
                                </v-card>
                            </v-card>

                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
export default {
    name: 'MediaLibraryBlock',
    props: ['attachments']
}
</script>

<style scoped>

</style>
